export default "__VITE_ASSET__B2z5vvy8__"